import { AuthUser } from "../models/AuthUser";
import AuthStorage from "../storages/AuthStorage";
import anonymousRestClient from "./clients/AnonymousRestClient";

/** Using given username and password to request a new JWT object from the AUTH service provider. */
export async function login(username: string, password: string): Promise<AuthUser | null> {

    try {

        let response = await anonymousRestClient.post<AuthUser>("/auth/login", { Username: username, Password: password })
        if (response.status === 200) {
            AuthStorage.setUser(response.data);
            return response.data;
        }
    }
    catch (error) { }

    return null;
}

/** Logs off the current user. Renders the current token invalid. */
export function logout() { 
    AuthStorage.destroy();
}